import { getMailCreatorAccountIds, getUnreadThreadMessageCountByIds, listUnreadMail} from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"

type Params = {
  accessToken: string
  accountId: string
  organizationId: string
  teamMemberId:string
}

export type UnreadResponse = {
  inbox: boolean
  outbox: boolean
}

export const hasUnreadThreadMessage = async ({accessToken, accountId, organizationId ,teamMemberId}: Params): Promise<UnreadResponse> => {
  /**
   *  accountId: ログインしているユーザーのアカウントID
   *  organizationId: ユーザーが選択している団体のID
   *  teamMemberId: ユーザーが選択している団体におけるユーザーのID(チームメンバーID)
   * 
   *  1. 未読のスレッド一覧を取得: 未読のmailIdsを取得
   *  2. 未読のスレッド一覧に対して、メールの作成者の`accountId`を取得
   *  3. メール作成者が自分の場合は`outbox`、他人の場合は`inbox` に未読のメールがあることを判定
   */
  const result = await execApi(
    () => getUnreadThreadMessageCountByIds(accessToken, {
      accountId,
      teamId: organizationId,
      aggrUnit: "account"
    }),
    res => res.searchThreadMessages.aggregateItems[0].result,
  )
  if (!result.isOk || result.content.buckets.length === 0) {
    return {
      inbox: false,
      outbox: false
    }
  }

  const mailIds = new Set<string>()
  result.content.buckets.every(doc => mailIds.add(doc.key))
  const mailIDs = result.content.buckets.map(bucket => ({
    mailID: {
      eq: bucket.key
    }
  }));

  const result2 = await execApi(
    () => listUnreadMail(accessToken, {
      teamMemberId,
      mailIDs,
    }),
    res => res.searchTeamMemberMails
  )

  if(result2.isOk && result2.content.total=== 0) {
    return {
      inbox: false,
      outbox: false
    }
  }

  const mailCreatorAccountIds = await execApi(() => getMailCreatorAccountIds(accessToken, { mailIds: Array.from(mailIds) }), res => res.getMailCreatorAccountIds.mailCreatorAccountIds)
  if (mailCreatorAccountIds.isOk) {
    return {
      inbox: mailCreatorAccountIds.content.some(item => item !== accountId),
      outbox: mailCreatorAccountIds.content.some(item => item === accountId)
    }
  } 
  return {
    inbox: false,
    outbox: false
  }
}
